import axios from '../axios-on-rails';

class ResumeSearches {
  constructor() {
    this.debounceCheckAllMember = this.debounce(this.ajaxCheckMemberAll.bind(this));
    this.debounceCheckSingleMember = this.debounce(this.ajaxCheckMemberSingle.bind(this));
  }

  ready() {
    this.hideIconLoading();

    $(document).ready(function () {
      $('.select-calendar select').addClass('form-control custom-select');
      $('.select-calendar select:nth-child(3n+1)').addClass('col-md-4 col-lg-3 mb-2 mb-lg-0');
      $('.select-calendar select:nth-child(3n),.select-calendar select:nth-child(3n+2)').addClass('col-md-3 col-lg-2 mb-2 mb-lg-0');
      $('.js-page-resume-search .modal').on('hidden.bs.modal', function (_e) {
        let $this = $(this)
        $this.find('.collapse').collapse('hide');
        $this.find('.js-custom-checkbox :checkbox').prop('checked', false);
        $this.find('.js-wrap-location').empty()
      });

      $('#js-submit-location-dersired').on('click', function () {
        let $checkbox = $('#js-checkbox-show-parent-location');
        let $output = $($checkbox.data('output'));
        let val = $checkbox.is(':checked') ? 1 : 0;

        $output.val(val)
      })

      $('#locationDesiredHomeTypeModal').on('show.bs.modal', function () {
        let isChecked = $('#js-show-parent-location').val().toString()

        $('#js-checkbox-show-parent-location').prop('checked', false)

        if (isChecked == '1') {
          $('#js-checkbox-show-parent-location').prop('checked', true)
        } else {
          $('#js-checkbox-show-parent-location').prop('checked', false)
        }
      })
    });
  }

  onchange(target) {
    let $this = $(target)
    let $wrapLocation = $this.closest('.modal').find('.js-wrap-location')
    let $selects = $wrapLocation.find('select')
    let $allVals = $selects.map(function() {
      return $(this).val()
    }).get()
    $selects.each(function() {
      let select = $(this)
      let selectedVal = select.val()
      select.find("option").removeAttr("disabled")
      $allVals.forEach(function(val) {
        if (selectedVal != val && val != '') {
          select.find("option[value='" + val + "']").attr("disabled", "disabled")
        }
      })
    })
  }

  getSearchSessionId(){
    const url = new URLSearchParams(window.location.search);
    return url.get('searchsession');
  }

  /**
  * ==== START SELECT DROPDOWN VIA MODAL
  * ⬇⬇⬇⬇
  */
  openModalSelect(target) {
    let $this = $(target);
    let $modal = $($this.data('modal'));
    let $wrapLocation = $modal.find('.js-wrap-location')
    let $template = $this.parent().siblings($this.data('templateContent'))
    let $groups = $this.parent().siblings($this.data('output')).find('div[id^="js-tsl"]')

    if ($groups.length) {
      $groups.each(function () {
        let $current_template = $(`<div class="js-location">${$template.html()}</div>`)
        $wrapLocation.append($current_template)

        $(this).find('input').each(function (idx) {
          let id = $(this).val()
          $($current_template.find('select').get(idx)).val(id).change()
        })
      })
    } else {
      let $current_template = $(`<div class="js-location">${$template.html()}</div>`)
      $wrapLocation.html($current_template)
    }

    if ($this.data('templateContent') == '#js-template-location-work-histories') {
      this.onchange($wrapLocation.find("select").first());
    }

    // Show modal
    $modal.modal('show');
  }

  addMoreLocation(target, idTemplate) {
    let $this = $(target);
    let $template = $(idTemplate).html();
    let $wrapLocation = $this.closest('.modal').find('.js-wrap-location');

    $wrapLocation.append(`<div class="js-location">${$template}</div>`);

    if (idTemplate == '#js-template-location-work-histories') {
      this.onchange($wrapLocation.find("select").first());
    }
  }

  onClickAgreeSelectLocation(target) {
    let $this = $(target)
    let $output = $($this.data('output'))
    let $modal = $this.parents('.modal')
    let $locations = $this.parent('.modal-footer').siblings('.modal-body').find('.js-location')
    let input_name = $this.data('inputName')
    let input_subnames = $this.data('inputSubname').split(',')
    let ids = []
    let text = []

    // Clear all tags
    $output.empty()

    // Show tags on UI
    $locations.each(function (idx) {
      let html = ''
      ids = []
      text = []

      $(this).find('option:selected').each(function () {
        if (!this.value) return true

        ids.push(this.value)
        text.push(this.text)
      })

      if (ids.length) {
        ids.forEach(function (id, idx) {
          html += `<input type="hidden" name="${input_name}[${input_subnames[idx]}]" value="${id}">`
        })

        html += `<span class="badge badge-pill badge-secondary">${text.join(' / ')}</span>`

        html = `<div id="js-tsl-${Number(new Date()) + idx}" class="badge-subgroup" onclick="ResumeSearches.onClickRemoveBadgeOption(this)">${html}</div>`

        $output.append(html)
      }
    })

    // Close modal
    $modal.modal('hide')
    $modal.find('.js-wrap-location').empty()
  }

  /**
  * ⬆⬆⬆⬆
  * ==== END SELECT DROPDOWN VIA MODAL
  */

  /**
  * ==== START CHECK AND UNCHECK VIA MODAL
  * ⬇⬇⬇⬇
  */
  openModalCheckbox(target) {
    let $this = $(target)
    let $modal = $($this.data('modal'))
    let $output = $($this.data('output'))

    // Unchecked all checkbox
    $modal.find(':checkbox').prop('checked', false)

    $output.find('input[type="hidden"]').each(function () {
      let $checkBox = $modal.find(`:checkbox[value="${this.value}"]`);
      $checkBox.prop('checked', true);
      $checkBox.closest('.collapse').addClass('show');
    })

    // ResumeSearches.changeNewJobTypeColor()

    // Show modal
    $modal.modal('show');
  }

  // DJ-2923 This is temporary, this should not be called after lots of members uses new job types.

  // static changeNewJobTypeColor() {
  //   const prefix_ids = ['resume-job-checkbox-', 'desired-job-custom-checkbox-'];
  //   // New Job Types
  //   const new_job_types = [ '205',  '206',  '308',  '309',  '310',
  //                           '311',  '312',  '313',  '314',  '315',
  //                           '316',  '508',  '509',  '510',  '511',
  //                           '613',  '614',  '615', '1011', '1116',
  //                          '1117', '1713', '1813', '1814', '1815',
  //                          '1816', '2116', '2117', '2118', '2119',
  //                          '2120', '2310', '2311', '2312', '2313',
  //                          '2404', '3003', '4317']

  //   $(prefix_ids).each(function(idx1, prefix_id) {
  //     $(new_job_types).each(function(idx2, new_job_type) {
  //       $('#' + prefix_id + new_job_type + ' + .custom-control-label').css('color','red');
  //     });
  //   });
  // }

  onClickAgreeOptions(target) {
    let $this = $(target)
    let $output = $($this.data('output'))
    let $modal = $this.parents('.modal')
    let checkboxes = $this.parent('.modal-footer').siblings('.modal-body').find(':checkbox:checked')
    let input_name = $this.data('inputName')

    // Clear all tags
    $output.empty();

    // Show tags on UI
    checkboxes.each(function (idx) {
      let $itself = $(this)
      let title = $itself.data('title')
      let id = $itself.val()
      let html = ''

      html += `<input type="hidden" name="${input_name}" value="${id}">`
      html += `<span class="badge badge-pill badge-secondary" data-id="${id}" >${title}</span>`

      $output.append(`<div id="js-tsl-${Number(new Date()) + idx}" class="badge-subgroup" onclick="ResumeSearches.onClickRemoveBadgeOption(this)">${html}</div>`)
    });

    // Close modal
    $modal.modal('hide')
  }

  onClickRemoveBadgeOption(target) {
    let $this = $(target)
    $this.fadeOut(200, function () { $this.remove() })
  }

  /**
  * ⬆⬆⬆⬆
  * ==== END CHECK AND UNCHECK VIA MODAL
  */

  /**
  * Safari fix.
  * Without this, the loading animation is still shown when the user clicks the back button.
  * https://stackoverflow.com/questions/8788802/prevent-safari-loading-from-cache-when-back-button-is-clicked
  */
  hideIconLoading() {
    window.addEventListener('pageshow', function () {
      $('.js_loading').css('display', 'none');
    });
  }

  showIconLoading() {
    $('.js_loading').css("display", "block")
  }

  debounce(func, delay = 250) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  ajaxCheckMemberAll(resume_search_result_id, checked) {
    axios({
      method: 'post',
      url: Routes.resumes_check_all_item_index_path(),
      data: {
        resume_search_result_id: resume_search_result_id,
        checked: checked,
        searchsession: this.getSearchSessionId()
      }
    }).then(({ data, status }) => {
      if (status == 200) {
        $('.js-checkbox-jobfolder,.js-checkbox-all').prop('checked', checked);
        this.showHideNotice(data.total_member_checked);
      }
    }).catch(error => {
      $('.js-checkbox-all').prop('checked', false);
      alert(gon.views.shared.models.mail_member.errors.mail_member_too_long)
    })
  }

  checkMemberAll(target, resume_search_result_id) {
    let checked = $(target).prop("checked");
    this.debounceCheckAllMember(resume_search_result_id, checked);
  }

  ajaxCheckMemberSingle(resume_search_result_id, memberID, checked) {
    axios({
      method: 'post',
      url: Routes.resumes_check_single_item_index_path(),
      data: {
        member_id: memberID,
        resume_search_result_id: resume_search_result_id,
        checked: checked,
        searchsession: this.getSearchSessionId()
      }
    }).then(({ data, status }) => {
      if (status == 200) {
        $('.js-checkbox-all').prop('checked', data.is_all_members_checked);
      }
    })
  }

  checkMemberSingle(target, resume_search_result_id) {
    let memberID = $(target).val();
    let checked  = $(target).prop("checked");
    let totalMemberSelected = parseInt($('[data-target="memberCount"]').text());
    totalMemberSelected     = checked ? (totalMemberSelected + 1) : (totalMemberSelected - 1);
    this.showHideNotice(totalMemberSelected);

    this.debounceCheckSingleMember(resume_search_result_id, memberID, checked);
  }

  showHideNotice(num) {
    let noticeElement = $('[data-target="notice"]');
    let memberCountElement = noticeElement.find('[data-target="memberCount"]');
    let scoutAvailable = memberCountElement.data('available');

    if (num > scoutAvailable) {
      noticeElement.addClass('alert alert-danger');
      $('[data-btn="sendAll"]').addClass('disabled');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      noticeElement.removeClass('alert alert-danger');
      $('[data-btn="sendAll"]').removeClass('disabled');
    }
    memberCountElement.text(num);
  }

  onclickPermanent(checkbox) {
    let form = checkbox.form;
    if (checkbox.checked) {
      form.js_search_title.disabled = false;
      form.js_search_title.focus();
    } else {
      form.js_search_title.disabled = true;
    }
  }

  onClickUseDate(form, objectName, fieldName, useFlag) {
    var year_select = this.findInputNamed(form, objectName + "[" + fieldName + "(1i)]");
    var month_select = this.findInputNamed(form, objectName + "[" + fieldName + "(2i)]");
    var day_select = this.findInputNamed(form, objectName + "[" + fieldName + "(3i)]");
    if (useFlag) {
      year_select.disabled = false;
      month_select.disabled = false;
      day_select.disabled = false;
    } else {
      year_select.selectedIndex = 0;
      year_select.disabled = true;
      month_select.selectedIndex = 0;
      month_select.disabled = true;
      day_select.selectedIndex = 0;
      day_select.disabled = true;
    }
  }

  findInputNamed(form, name) {
    var e = form.elements;
    for (var i = 0; i < e.length; ++i) {
      if (e[i].name == name) {
        return e[i];
      }
    }
    return null;
  }

  setdisable1(obj) {
    var l1 = $('#search_min_other_language1_level_id');
    var l2 = $('#search_max_other_language1_level_id');
    if (obj && obj.value == '') {
      l1.attr('disabled', 'disabled');
      l2.attr('disabled', 'disabled');
      l1.val('');
      l2.val('');
    } else {
      l1.removeAttr('disabled');
      l2.removeAttr('disabled');
    }
  }

  setdisable2(obj) {
    var l1 = $('#search_min_other_language2_level_id');
    var l2 = $('#search_max_other_language2_level_id');
    if (obj && obj.value == '') {
      l1.attr('disabled', 'disabled');
      l2.attr('disabled', 'disabled');
      l1.val('');
      l2.val('');
    } else {
      l1.removeAttr('disabled');
      l2.removeAttr('disabled');
    }
  }

  saveSendOption(search_id, selected_id, has_manager) {
    if (has_manager == 1) {
      axios({
        method: 'post',
        url: Routes.update_email_language_resumes_searches_path(gon.locale),
        data: {
          search_id: search_id,
          selected_id: selected_id
        }
      }).then((res) => {
        if (res.data.status != 'ok') {
          $("#searches-error-message").text(res.data.message).fadeIn('fast', function () {
            $(this).delay(3000).fadeOut('fast');
          });
        }
      });

    } else {
      var rd = document.getElementsByName(search_id);
      for (var i = 0; i < rd.length; i++) {
        if (rd[i].value == "0") {
          rd[i].checked = true;
          rd[i].focus();
          break;
        }
      }
      alert(gon.alert_email)
    }
  }

  checkReceivers(event) {
    event.preventDefault();
    let form = $(event.currentTarget).parents('form');
    let amountManagers = form.serializeArray().filter(ele => ele.name === 'managers[]').length
    if (amountManagers > 3) {
      alert(gon.views.shared.select_max_receiver_is_three)
    }
    else if (amountManagers > 0) {
      form.submit();
    }
    else {
      alert(gon.views.shared.select_one_at_least)
    }
  }
}

export default new ResumeSearches();
